import LuxonUtils from "@date-io/luxon";
import { ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import firebase from "firebase/app";
import { Settings } from "luxon";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { BrowserRouter } from "react-router-dom";
import { createFirestoreInstance } from "redux-firestore";
import {
    AuthIsReady,
    LoggedUserProvider,
    SeasonProvider,
} from "ui/componentes";
import { IRBTheme } from "ui/theme";
import App from "./App";
import "./config/firebaseConfig";
import "./index.css";
import store from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import "fontsource-roboto";

Settings.defaultLocale = "pt-br";

ReactDOM.render(
    <Provider store={store}>
        <ReactReduxFirebaseProvider
            config={{
                useFirestoreForProfile: true,
                userProfile: "users",
                attachAuthIsReady: true,
                useFirestoreForStorageMeta: true,
            }}
            firebase={firebase}
            dispatch={store.dispatch}
            createFirestoreInstance={createFirestoreInstance}
        >
            <ThemeProvider theme={IRBTheme}>
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                    <AuthIsReady>
                        <SeasonProvider>
                            <LoggedUserProvider>
                                <BrowserRouter>
                                    <SnackbarProvider maxSnack={3}>
                                        <App />
                                    </SnackbarProvider>
                                </BrowserRouter>
                            </LoggedUserProvider>
                        </SeasonProvider>
                    </AuthIsReady>
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </ReactReduxFirebaseProvider>
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
